module.exports = __webpack_public_path__ + "static/img/bg-mall-designer-list.8429a587.png";